module.exports = __webpack_public_path__ + "static/media/03_05_06.181c1fb7.png";